<template>
  <div :style="{ 'margin-bottom': window.isDesktop ? 0 : '15px' }">
    <div>
      <div style="display: inline" class="custom-control custom-checkbox" :id="'trackcheckbox' + track.gpsTrack.id">
        <b-form-checkbox class="display-inline" style="margin-right: 2px" v-model="checked" :id="'checkbox' + track.gpsTrack.id">
        </b-form-checkbox>
        <label class="custom-control-label" :for="'checkbox' + track.gpsTrack.id"></label>
        <span @mouseover="highlightMapTrack" @mouseleave="unhighlightMapTrack">
          <span style="margin-right: 2px;" @click="() => { checked = !checked }">{{ track.gpsTrack.name }}</span>
          <span class="badge bg-dark" :style="window.isPwa ? 'margin-right: 1px; padding-left: 2px; padding-right: 2px;' : 'margin-right: 2px;'">{{ formatDateDay(track.gpsTrack.start_time) }}</span>
          <span :class="getDisanseBadgeClasses(track.gpsTrack)" :style="window.isPwa ? 'margin-right: 1px; padding-left: 2px; padding-right: 2px;' : 'margin-right: 2px;'">{{
            roundTrackDistance(track.gpsTrack.distance) }}</span>
          <span v-if="track.gpsTrack.elevation_gain !== null" :class="getElevationGainBadgeClasses(track.gpsTrack)"
            :style="window.isPwa ? 'margin-right: 1px; padding-left: 2px; padding-right: 2px;' : 'margin-right: 2px;'">{{ track.gpsTrack.elevation_gain }}m</span>
          <span style="margin-right: 2px;" va-b-tooltip.hover :title="'' + track.gpsTrack.photos.length + ' ' + $t('photos')">
            <img v-if="track.gpsTrack.photos.length" @click="(event) => openTrackGallery(event, track, 0)" style="height: 20px; cursor: pointer;" :src="icons.images" />
          </span>
          <span va-b-tooltip.hover :title="'' + track.gpsTrack.videos.length + ' ' + $t('videos')">
            <img v-if="track.gpsTrack.videos.length" @click="openTrackVideos(track)" style="height: 20px; cursor: pointer;" :src="icons.video" />
          </span>
          <div style="float: right;">
            <img @click="togglePanel(); renderComponent = true;" style="height: 13px; cursor: pointer;" :src="iconsVisible ? icons.chevronUp : icons.chevronDown" />
          </div>
        </span>
      </div><br>
      <div style="display: none">
        <div :id="'tooltip' + track.gpsTrack.id" v-if="window.isDesktop">
          <b>{{ $t('name') }}: </b>{{ track.gpsTrack.name }}<br>
          <b>{{ $t('startTime') }}: </b>{{ formatDate(track.gpsTrack.start_time) }}<br>
          <b>{{ $t('distance') }}: </b>{{ roundTrackDistance(track.gpsTrack.distance) }}<br>
          <b>{{ $t('type') }}: </b>
          <TrackTypeIcon :gpsTrack="track.gpsTrack" height=12 imgheight=12 verticalAlign="-2px"></TrackTypeIcon><br>
          <b>{{ $t('status') }}: </b>
          <TrackStatusIcon :gpsTrack="track.gpsTrack" height=12></TrackStatusIcon><br>
          <b>{{ $t('id') }}: </b>{{ track.gpsTrack.id }}
        </div>
      </div>
      <div v-if="renderComponent">
        <div v-show="iconsVisible" ref="icons" style="display: block;" :style="{ 'margin-top': window.isDesktop ? '0px' : '5px' }">
          <div ref="colorDiv" style="display: inline-block; margin-right: 3px;"><color-popover :track="track" :height="window.isDesktop ? '24px' : '32px'"
              :width="window.isDesktop ? null : '32px'"></color-popover></div>
          <!--<b-tooltip v-if="(renderedComponent) && (window.isDesktop)" :target="$refs.colorDiv">{{ $t('changeColor') }}</<b-tooltip>-->
          <span v-if="window.isDesktop" style='margin-right: 3px;'>
            <TrackTypeIcon :gpsTrack="track.gpsTrack" height=24 imgheight=16 verticalAlign="2px"></TrackTypeIcon>
          </span>
          <span v-if="window.isDesktop" style='margin-right: 3px;'>
            <TrackStatusIcon :gpsTrack="track.gpsTrack" height=24></TrackStatusIcon>
          </span>
          <span style='margin-right: 3px;'>
            <TrackDownload :gpsTrack="track.gpsTrack" :height="window.isDesktop ? '24' : '32'" :width="window.isDesktop ? null : '32px'"></TrackDownload>
          </span>
          <span v-if="window.isDesktop" style='margin-right: 3px;' va-b-tooltip.hover :title="$t('centerTrack')">
            <img @click="centerTrack" style="height: 24px; cursor: pointer;" :src="icons.center" />
          </span>
          <span v-if="window.isDesktop" ref="tooltipSpan" style='margin-right: 3px;'>
            <img @click="playTrack" style="height: 24px; cursor: pointer;" :src="playing ? icons.stop : icons.play" />
          </span>
          <span v-if="(window.isDesktop) && (showDetails)" style='margin-right: 3px;' va-b-tooltip.hover :title="$t('maximizeTrack')">
            <img @click="detailsClick" style="height: 24px; cursor: pointer;" :src="icons.maximize" />
          </span>
          <span v-if="window.isDesktop" style='margin-right: 3px;' va-b-tooltip.hover :title="$t('analyzeTrack')">
            <img @click="openAnalyze" style="height: 24px; cursor: pointer;" :src="icons.chart" />
          </span>
          <!--<b-tooltip v-if="(track.gpsTrack.status === TrackStatus.done) && (renderedComponent) && (window.isDesktop)" :target="$refs.tooltipSpan">{{ playing ? $t('stopTrack') : $t('playTrack') }}</<b-tooltip>-->
          <span v-if="($store.state.user) && (window.isDesktop)">
            <span v-if="track.onServer" va-b-tooltip.hover :title="$t('saveTrack')">
              <img @click="showUploadModal" style="height: 24px; cursor: pointer;" :src="icons.save" />
            </span>
            <span v-else va-b-tooltip.hover :title="$t('uploadTrack')">
              <img @click="showUploadModal" style="height: 24px; cursor: pointer;" :src="icons.upload" />
            </span>
            <span style='margin-right: 3px;'></span>
          </span>
          <span style="display: inline-block; margin-right: 3px;" @click="toggleRuler">
            <img :style="{ 'cursor': 'pointer', 'height': window.isDesktop ? '24px' : '32px', 'width': window.isDesktop ? null : '32px' }"
              :src="rulerActive ? icons.rulerVertical : icons.rulerHorizontal" />
          </span>
          <span v-if="isPlannedTrack(track.gpsTrack) || isBorderTrack(track.gpsTrack)">
            <span v-if="track === $store.state.editedTrack">
              <img @click="setEdited(null)" style="height: 24px; cursor: pointer" :src="icons.unlock" />
            </span>
            <span v-else>
              <img @click="setEdited(track)" style="height: 24px; cursor: pointer" :src="icons.lock" />
            </span>
          </span>
          <span v-if="!track.onServer" style='margin-right: 3px;' va-b-tooltip.hover :title="$t('removeTrack')">
            <img @click="removeImportedTrack(); removePlannedTrack();" style="height: 24px; cursor: pointer;" :src="icons.trash" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import L from 'leaflet';
import BaseComponent from '@/components/Base.vue';
import Track from '@/ts/Track';
import { TrackStatus } from '@/ts/types';
import { formatDate, formatDateDay, roundTrackDistance } from '@/ts/utils';
import { distanceBetweenPoints } from '@/ts/utils/coords';
import { EventBus } from '@/ts/EventBus';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  extends: BaseComponent,
  data() {
    const rulerMarkers: L.CircleMarker[] = [];
    const playing: boolean = false;
    const renderComponent: boolean = false;
    const iconsVisible: boolean = true;
    const checked: boolean = undefined;

    return {
      checked,
      iconsVisible,
      renderComponent,
      playing,
      rulerActive: false,
      highlighted: false,
      rulerMarkers
    };
  },
  created() {
    this.checked = this.track.checked;
  },
  mounted() {
    this.refreshTooltip();
    this.showOrHideTrack();
    this.togglePanel();
    for (const animateTrack of window.tracks[this.track.id].animateTracks) {
      //@ts-ignore
      animateTrack.on(L.Motion.Event.Ended, (event: Event) => {
        if (this.playing) {
          //@ts-ignore
          if (event.target.animateTrackIndex === window.tracks[this.track.id].animateTracks.length - 1) {
            this.playing = false;
            for (const animateTrackIn of window.tracks[this.track.id].animateTracks) {
              animateTrackIn.removeFrom(window.mainmap);
            }
            if (this.checked) {
              for (const mapTrack of window.tracks[this.track.id].mapTracks) {
                mapTrack.addTo(window.mainmap);
              }
            }
          } else {
            //@ts-ignore
            window.tracks[this.track.id].animateTracks[event.target.animateTrackIndex + 1].addTo(window.mainmap);
            //@ts-ignore
            window.tracks[this.track.id].animateTracks[event.target.animateTrackIndex + 1].motionStart();
          }
        }
      });
    }
    this.changeColor();
    if (this.highlightOnStart) {
      this.highlightMapTrack(null);
    }
  },
  beforeDestroy() {
    if (this.rulerActive) {
      this.toggleRuler();
    }
  },
  methods: {
    showUploadModal() {
      EventBus.$emit('openSaveTrackModal' + this.track.gpsTrack.id);
    },
    refreshTooltip() {
      if (window.isDesktop) {
        for (const mapTrack of window.tracks[this.track.id].mapTracks) {
          if ((this.track.gpsTrack.status != TrackStatus.planned) && (this.track.gpsTrack.status != TrackStatus.border)) {
            const element = document.getElementById('tooltip' + this.track.gpsTrack.id);
            mapTrack.bindTooltip(element, {sticky: true, opacity: 0.95});
          }
          mapTrack.on('mouseover', (e: L.LeafletMouseEvent) => {
            this.highlightMapTrack(e);
          });
          mapTrack.on('mouseout', (e: L.LeafletMouseEvent) => {
            this.unhighlightMapTrack();
          });
          mapTrack.off('click');
          mapTrack.on('click', (e: L.LeafletMouseEvent) => {
            if (! this.$store.state.editedTrack) {
              if ((this.track.gpsTrack.status == TrackStatus.planned) || (this.track.gpsTrack.status == TrackStatus.border)) {
                if (e.originalEvent.ctrlKey || e.originalEvent.metaKey || e.originalEvent.shiftKey) {
                  if (! this.track.onServer) {
                    for (const mt of window.tracks[this.track.id].mapTracks) {
                      mapTrack.off('click');
                      mapTrack.off('mouseover');
                      mapTrack.off('mouseout');
                    }
                    this.track.removeMapObjects(window.mainmap);
                    this.$store.commit('removePlannedTrack', this.track);
                  }
                } else {
                  this.$store.commit('setEditedTrack', this.track);
                }
                L.DomEvent.stopPropagation(e);
              } else {
                this.detailsClick();
                L.DomEvent.stopPropagation(e);
              }
            }
          });
        }
      } else {
        if (this.track.gpsTrack.status == TrackStatus.planned) {
          for (const mapTrack of window.tracks[this.track.id].mapTracks) {
            mapTrack.off('click');
            mapTrack.on('click', (e: L.LeafletMouseEvent) => {
              if ((! this.$store.state.editedTrack) && (e.originalEvent.pointerType == 'pen')) {
                this.$store.commit('setEditedTrack', this.track);
                L.DomEvent.stopPropagation(e);
              }
            });
          }
        }
      }
    },
    setEdited(track: Track) {
      this.$store.commit('setEditedTrack', track);
      if (track) {
        track.checked = true;
      }
    },
    togglePanel() {
      //$(this.$refs.icons).slideToggle('fast');
      this.iconsVisible = !this.iconsVisible;
    },
    centerTrack() {
      const trackBounds = new L.LatLngBounds(window.tracks[this.track.id].mapTracks[0].getBounds().getNorthEast(), window.tracks[this.track.id].mapTracks[0].getBounds().getSouthWest());
      for (const mapTrack of window.tracks[this.track.id].mapTracks) {
        trackBounds.extend(mapTrack.getBounds());
      }
      window.mainmap.fitBounds(trackBounds);
    },
    openAnalyze() {
      window.open('/trackanalyze/' + this.track.gpsTrack.id + '/', '_blank');
    },
    playTrack() {
      if (!this.playing) {
        for (const mapTrack of window.tracks[this.track.id].mapTracks) {
          mapTrack.removeFrom(window.mainmap);
        }
        let index = 0;
        for (const loopIndex in Object.keys(window.tracks[this.track.id].animateTracks)) {
          if (window.tracks[this.track.id].animateTracks.hasOwnProperty(loopIndex)) {
            const animateTrack = window.tracks[this.track.id].animateTracks[loopIndex];
            //@ts-ignore
            animateTrack.motionOptions.duration = (this.track.gpsTrack.distance / this.$store.state.playingSpeed) * (this.track.gpsTrack.segments[loopIndex].distance / this.track.gpsTrack.distance);
            if (this.track.gpsTrack.isWalkTrack() || this.track.gpsTrack.isMushroomTrack()) {
              //@ts-ignore
              animateTrack.motionOptions.duration = animateTrack.motionOptions.duration * 10;
            }
            //@ts-ignore
            animateTrack.animateTrackIndex = index;
            index = index + 1;
            animateTrack.options.color = this.track.gpsTrack.color;
          }
        }
        window.tracks[this.track.id].animateTracks[0].addTo(window.mainmap);
        //@ts-ignore
        window.tracks[this.track.id].animateTracks[0].motionStart();
        this.playing = true;
      } else {
        //@ts-ignore
        window.tracks[this.track.id].animateTracks[window.tracks[this.track.id].animateTracks.length - 1].motionStop();
      }
    },
    highlightMapTrack(e: MouseEvent | L.LeafletMouseEvent) {
      if (e && 'latlng' in e) {
        if (e.target._tooltip) {
          if (e.latlng.lng < window.tracks[this.track.id].startMarker.getLatLng().lng) {
            e.target._tooltip.options.direction = 'left';
          } else {
            e.target._tooltip.options.direction = 'right';
          }
        }
      }
      this.highlighted = true;
      document.getElementById('trackcheckbox' + this.track.gpsTrack.id).style.fontWeight = 'bold';
      this.changeWidth(6);
      for (const mapTrack of window.tracks[this.track.id].mapTracks) {
        mapTrack.bringToFront();
      }
      if (this.track.checked) {
        if (window.tracks[this.track.id].startMarker) {
          window.tracks[this.track.id].startMarker.addTo(window.mainmap);
        }
        if (window.tracks[this.track.id].finishMarker) {
          window.tracks[this.track.id].finishMarker.addTo(window.mainmap);
        }
      }
    },
    unhighlightMapTrack() {
      this.highlighted = false;
      document.getElementById('trackcheckbox' + this.track.gpsTrack.id)!.style.fontWeight = 'normal';
      this.changeWidth(3);
      if (window.tracks[this.track.id].startMarker) {
        window.tracks[this.track.id].startMarker.removeFrom(window.mainmap);
      }
      if (window.tracks[this.track.id].finishMarker) {
        window.tracks[this.track.id].finishMarker.removeFrom(window.mainmap);
      }
    },
    changeWidth(width: number) {
      for (const mapTrack of window.tracks[this.track.id].mapTracks) {
        mapTrack.setStyle({
          weight: width,
        });
      }
    },
    changeColor() {
      for (const mapTrack of window.tracks[this.track.id].mapTracks) {
        mapTrack.setStyle({
          color: this.track.gpsTrack.color,
        });
      }
    },
    changeStyle() {
      for (const mapTrack of window.tracks[this.track.id].mapTracks) {
        const dashArray = this.track.convertStyleIDToDash(this.track.gpsTrack.style);
        mapTrack.setStyle({
          dashArray: dashArray,
        });
      }
    },
    createRulerMarkers() {
      this.rulerMarkers = [];
      for (const segment of this.track.gpsTrack.segments) {
        let lastDistance = -2000;
        let lastPoint: L.LatLng = null;
        let distance = 0;
        for (const point of segment.pointsArray) {
          if (lastPoint) {
            distance = distance + distanceBetweenPoints(point.lat, point.lng, lastPoint.lat, lastPoint.lng);
            if (distance >= lastDistance + 1000) {
              lastDistance = distance;
              const marker = new L.CircleMarker(point, { radius: 5 });
              let decimalPlaces = 1;
              if ((distance > 0) && (distance < 2500)) {
                decimalPlaces = 3;
              }
              marker.bindTooltip((distance / 1000).toFixed(decimalPlaces), { permanent: true, className: 'smallTooltip', direction: 'right' });
              this.rulerMarkers.push(marker);
            }
            lastPoint = point;
          } else {
            lastPoint = point;
          }
        }
      }
    },
    detailsClick() {
      if (!this.$store.state.trackDetailsActivated.includes(this.track)) {
        this.$store.state.trackDetailsActivated.push(this.track);
      }
      this.track.maximized = true;
    },
    toggleRuler() {
      if (this.rulerMarkers.length === 0) {
        this.createRulerMarkers();
      }
      this.rulerActive = !this.rulerActive;
      this.showOrHideTrack();
    },
    showOrHideTrack() {
      if (this.checked) {
        for (const mapTrack of window.tracks[this.track.id].mapTracks) {
          mapTrack.addTo(window.mainmap);
        }
        if (this.highlighted) {
          if (window.tracks[this.track.id].startMarker) {
            window.tracks[this.track.id].startMarker.addTo(window.mainmap);
          }
          if (window.tracks[this.track.id].finishMarker) {
            window.tracks[this.track.id].finishMarker.addTo(window.mainmap);
          }
        }
        if (this.rulerActive) {
          for (const marker of this.rulerMarkers) {
            marker.addTo(window.mainmap);
          }
        } else {
          for (const marker of this.rulerMarkers) {
            marker.removeFrom(window.mainmap);
          }
        }
        if (this.$store.state.editedTrack === this.track) {
          for (const marker of window.tracks[this.track.id].plannedMarkers) {
            marker.addTo(window.mainmap);
          }
          for (const marker of window.tracks[this.track.id].middleMarkers) {
            marker.addTo(window.mainmap);
          }
        }
        this.track.checked = true;
      } else {
        for (const mapTrack of window.tracks[this.track.id].mapTracks) {
          mapTrack.removeFrom(window.mainmap);
        }
        if (window.tracks[this.track.id].startMarker) {
          window.tracks[this.track.id].startMarker.removeFrom(window.mainmap);
        }
        if (window.tracks[this.track.id].finishMarker) {
          window.tracks[this.track.id].finishMarker.removeFrom(window.mainmap);
        }
        for (const marker of window.tracks[this.track.id].plannedMarkers) {
          marker.removeFrom(window.mainmap);
        }
        for (const marker of window.tracks[this.track.id].middleMarkers) {
          marker.removeFrom(window.mainmap);
        }
        for (const marker of this.rulerMarkers) {
          marker.removeFrom(window.mainmap);
        }
        this.track.checked = false;
      }
    },
    removeImportedTrack() {
      if (this.rulerActive) {
        this.toggleRuler();
      }
      this.track.removeMapObjects(window.mainmap);
      this.$store.commit('removeImportedTrack', this.track);
    },
    removePlannedTrack() {
      if (this.rulerActive) {
        this.toggleRuler();
      }
      if (this.track === this.$store.state.editedTrack) {
        this.$store.commit('setEditedTrack', null);
      }
      this.track.removeMapObjects(window.mainmap);
      this.$store.commit('removePlannedTrack', this.track);
    },
    onEditedTrackChanged() {
      if (this.$store.state.editedTrack === this.track) {
        for (const marker of window.tracks[this.track.id].plannedMarkers) {
          marker.addTo(window.mainmap);
        }
        for (const marker of window.tracks[this.track.id].middleMarkers) {
          marker.addTo(window.mainmap);
        }
      } else {
        for (const marker of window.tracks[this.track.id].plannedMarkers) {
          marker.removeFrom(window.mainmap);
        }
        for (const marker of window.tracks[this.track.id].middleMarkers) {
          marker.removeFrom(window.mainmap);
        }
      }
    },
    onPropCheckedChanged(value: boolean, oldValue: boolean) {
      this.checked = this.track.checked;
    },
    onCheckedChanged(value: boolean, oldValue: boolean) {
      this.showOrHideTrack();
    },
    onColorChanged(value: string, oldValue: string) {
      this.changeColor();
    },
    onStyleChanged(value: string, oldValue: string) {
      this.changeStyle();
    },
    onPointsChanged(value: string, oldValue: string) {
      this.showOrHideTrack();
      this.refreshTooltip();
    }
  },
  props: {
    track: {
      required: true,
      type: Object as PropType<Track>
    },
    highlightOnStart: {
      required: true,
      type: Boolean
    },
    showDetails: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    "$store.state.editedTrack": [{
      handler: "onEditedTrackChanged"
    }],
    "track.checked": [{
      handler: "onPropCheckedChanged"
    }],
    "checked": [{
      handler: "onCheckedChanged"
    }],
    "track.gpsTrack.color": [{
      handler: "onColorChanged"
    }],
    "track.gpsTrack.style": [{
      handler: "onStyleChanged"
    }],
    "track.lastRefresh": [{
      handler: "onPointsChanged"
    }]
  }
})

</script>

<style>
.smallTooltip {
  padding: 1px;
  margin: 0px;
  margin-left: 10px;
  border: 1px solid black;
  font-size: 0.7rem;
}

.leaflet-layer2 {
  z-index: 1000000 !important;
}

.badge-green1 {
  color: white;
  background-color: rgb(108, 217, 98)
}

.badge-green2 {
  color: white;
  background-color: rgb(60, 179, 49);
}

.badge-green3 {
  color: white;
  background-color: rgb(44, 145, 35);
}

.badge-green4 {
  color: white;
  background-color: rgb(7, 79, 0);
}

.badge-red1 {
  color: white;
  background-color: rgb(255, 180, 180);
}

.badge-red2 {
  color: white;
  background-color: rgb(255, 100, 100);
}

.badge-red3 {
  color: white;
  background-color: rgb(220, 50, 50);
}

.badge-red4 {
  color: white;
  background-color: rgb(180, 0, 0);
}
</style>